<template>
  <div id="wrap">
    <SideView ref="refSideMenu"/>
    <div id="container" ref="refContainer">
      <HeaderView/>
      <div class="container-inner">
        <SlideTabView @toggle="toggleBtn" :defaultTabs="defaultTabs"/>
      </div>
    </div>
  </div>
</template>

<script>
import SideView from '@/layout/admin/components/SideView'
import HeaderView from '@/layout/admin/components/HeaderView'
import SlideTabView from '@/layout/admin/components/SlideTabView'

export default {
  name: 'AdminComponent',
  components: {
    HeaderView,
    SideView,
    SlideTabView
  },
  data () {
    return {
      defaultTabs: []
    }
  },
  created () {
    console.log("Created.. Admin index.vue")
    console.log('created AdminComponent..')
    const tab = {
      tabName: this.$route.name,
      tabComponent: this.$route.meta.component,
      currentTab: 0,
      show: true
    }

    this.$set(this.defaultTabs, this.defaultTabs.length, tab)
  },
  methods: {
    toggleBtn () {
      const sideMenu = this.$refs.refSideMenu.$refs.refSideBar
      const contariner = this.$refs.refContainer
      this.toggle = !this.toggle
      if (this.toggle === false) {
        sideMenu.style.left = '0px'
        contariner.style.padding = '0 24px 30px 280px'
      } else {
        sideMenu.style.left = '-255px'
        contariner.style.padding = '0 24px 30px 20px'
      }
    }
  }
}
</script>

<style scoped>
@import '../../assets/admin/css/common.css';
</style>
